import { Link } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                511
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90">
              {siteInfo.slogan}。尊重事实、保护隐私，是我们处理每一条爆料的前提。
            </p>
            <p className="mt-4 text-sm text-background-300/80 flex items-center gap-2">
              <i className="ri-time-line"></i>
              {siteInfo.workingHours}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="inline-flex items-center gap-2 text-background-200/90 hover:text-background-50 transition-colors"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/square?category=${cat.id}`}
                    className="inline-flex items-center gap-2 text-background-200/90 hover:text-background-50 transition-colors"
                  >
                    <i className={`${cat.icon} text-accent-300`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2 text-background-200/90">
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line"></i>
                </span>
                <span>
                  爆料线索：{siteInfo.email}
                  <br />
                  <span className="text-background-300/80 text-xs">投诉与撤回请注明线索编号</span>
                </span>
              </li>
              <li className="flex items-start gap-2 text-background-200/90">
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-briefcase-line"></i>
                </span>
                <span>商务合作：{siteInfo.bizEmail}</span>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-message-3-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-background-100"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300/80">
          <p>© 2026 {siteInfo.name}. 内容由用户匿名投稿，平台仅作信息汇集与核实协作。</p>
          <p>请勿编造或传播未经核实的指控，理性吃瓜，尊重他人隐私。</p>
        </div>
      </div>
    </footer>
  );
}